import { ReactNode, useEffect, useState } from "react";
import TopBar from "./TopBar";
import { Outlet, useLocation, useNavigate } from "react-router-dom";
import {
  Center,
  Container,
  Flex,
  Group,
  Loader,
  Navbar,
  ScrollArea,
} from "@mantine/core";
import styled from "@emotion/styled";

import { create, useStore } from "zustand";
import { checkToken, useAuth } from "../auth/AuthContext";
import { preload } from "swr";
import {
  getApiCallGetCallList,
  getApiOrganizationGetOrganizations,
  getGetApiCallGetCallListKey,
  getGetApiOrganizationGetOrganizationsKey,
} from "../api/endpoints";
import OrganizationMenu from "./Organization";
import { AXIOS_INSTANCE } from "../api/axios-instance";

const StyledContainer = styled(Container)`
  padding-top: 5rem;
  flex: 1 1 auto;
  overflow: auto;
  max-width: 90rem;
`;

const StyledFlex = styled(Flex)`
  background-color: #fafafa;
`;

type SidebarStoreState = {
  content: ReactNode | null;
  setContent: (content: ReactNode) => void;
  sidebarOpen: boolean;
  setSidebarOpen: (open: boolean) => void;
};

export const sidebarStore = create<SidebarStoreState>((set) => ({
  content: null,
  setContent: (content: ReactNode) => set({ content }),
  sidebarOpen: false,
  setSidebarOpen: (open: boolean) => set({ sidebarOpen: open }),
}));

function Layout() {
  const location = useLocation();
  
  const sidebarContent = useStore(sidebarStore, (state) => state.content);
  const isLoginCallback = location.pathname === "/login-callback";

  const setSidebarOpen = useStore(
    sidebarStore,
    (state) => state.setSidebarOpen
  );
  const isSidebarOpen = useStore(sidebarStore, (state) => state.sidebarOpen);
  const navigate = useNavigate();
  const auth = useAuth();
  const [hasNetworkError, setHasNetworkError] = useState(false);

  const isAuthenticated =
    // !!auth.isAuthenticated &&
    checkToken(auth.access_token!) &&
    !!auth.access_token &&
    auth.access_token !== "null" &&
    auth.access_token !== "" &&
    auth.user;

  // useEffect(() => {
  //   const interceptorId = AXIOS_INSTANCE.interceptors.response.use(
  //     (response) => response,
  //     (error) => {
  //       if (error.code === "ERR_NETWORK") {
  //         setHasNetworkError(true);
  //         // debugger
  //         navigate("/", { replace: true });
  //       }
  //       return Promise.reject(error);
  //     }
  //   );
  //
  //   return () => {
  //     AXIOS_INSTANCE.interceptors.response.eject(interceptorId);
  //   };
  // }, []);

  useEffect(() => {
    if (!hasNetworkError) {
      sidebarStore.setState({ content: null });

      if (location.pathname === "/" && isAuthenticated) {
        preload(getGetApiCallGetCallListKey(), getApiCallGetCallList);
        preload(
          getGetApiOrganizationGetOrganizationsKey(),
          getApiOrganizationGetOrganizations
        );
        navigate("/calls", { replace: true });
      } else if (
        location.pathname !== "/" &&
        !isAuthenticated &&
        !auth.isLoading
      ) {
        navigate("/", { replace: true });
      }
    } else if (
      location.pathname !== "/" &&
      !isAuthenticated &&
      !auth.isLoading
    ) {
      // debugger
      navigate("/", { replace: true });
    }
  }, [location.pathname, isAuthenticated, hasNetworkError]);

  useEffect(() => {
    setSidebarOpen(isAuthenticated ? true : false);
  }, [isAuthenticated, auth, auth.isLoading]);

  if (auth.isLoading && !isLoginCallback) {
    console.log("Loading");
    return (
      <Center style={{ marginTop: "25%" }}>
        <Loader />
      </Center>
    );
  }

  return (
    <StyledFlex direction="column">
      {isAuthenticated && location.pathname !== "/" && <TopBar />}
      <Flex mt={30} style={{ zIndex: 1, height: "100vh" }}>
        {isAuthenticated && location.pathname !== "/" && isSidebarOpen && (
          <Navbar width={{ base: 300 }} pt={60} px={20} h={window.innerHeight}>
            <ScrollArea h={window.innerHeight}>
              <Group grow mx="-xs" px="xs" py={"xs"}>
                {sidebarContent ?? <OrganizationMenu />}
              </Group>
            </ScrollArea>
          </Navbar>
        )}
        <StyledContainer w={{ sm: 800, md: 1024, lg: 1080, xl: 1400 }} pb={100}>
          <Outlet />
        </StyledContainer>
      </Flex>
    </StyledFlex>
  );
}

export default Layout;
